
<div id="sandhub-workarea">
  <div class="title-bar-area">
    <div class="title-area">{{title}}</div>
  </div>
</div>
<div>
  <div id="formWordOfTheWeek">
    <input data-val="true" data-val-required="The Id field is required." id="id" name="Id" type="hidden" value="00000000-0000-0000-0000-000000000000">
    <div class="curation-row row mt-4">
      <label class="curation-label col-md-1" for="startDate">
        Start Date:
      </label>
      <div class="text-entry-calendar col-md-3">
        <input  type="date" [(ngModel)]="startDate" name="startDate" id="startDate"/>
      </div>
    </div>
    <div class="curation-row row mt-4">
      <label class="curation-label col-md-1" for="word">
        Word:
      </label>
      <div class="text-entry-calendar col-md-3">
        <input type="text" id="Word" name="Word" [(ngModel)]="word">
      </div>
    </div>
    <div class="curation-row row mt-4">
      <label class="curation-label col-md-1" for="details">
        Details:
      </label>
      <div class="curation-form-input col-md-10">
        <ckeditor [(ngModel)]="details" editorUrl="https://cdn.ckeditor.com/4.14.0/full/ckeditor.js" [config]="ckEditorConfig" (ready)="onCkEditorReady($event)"></ckeditor>
      </div>
    </div>
    <div class="curation-edit-buttons">
      <div class="curation-item-submit" style="background:none;" *ngIf="wordOftheWeekId==''">
        <input style="height: 35px; color: white; background: #284a7b;" id="saveWordOfTheWeek" (click)="validateWordOfTheWeek();" type="button" class="btn btn-default" value="SAVE">
      </div>
      <div class="curation-item-submit" style="background:none;" *ngIf="wordOftheWeekId!=''">
        <input style="height: 35px; color: white; background: #284a7b;" id="saveWordOfTheWeek" (click)="validateWordOfTheWeek();" type="button" class="btn btn-default" value="UPDATE">
      </div>
      <div class="curation-item-submit" style="background:none;">
        <input style="height: 35px; color: white; background: #284a7b;" id="cancelSmartBankItem"  type="button" value="CANCEL" (click)="cancel();" class="btn btn-default">
      </div>
    </div>
  </div>
</div>




